module.exports = __webpack_public_path__ + "img/ee.d9c33947.svg";